import { useState } from 'react';
import content from '../content.json';
const pub = process.env.PUBLIC_URL;

export default function DiscoverEscape() {
  const [hovered, setHovered] = useState(null);

  return (
    <section style={{ background: 'var(--dark2)', padding: '100px 0' }}>
      <div style={{ maxWidth: '1160px', margin: '0 auto', padding: '0 48px' }}>
        <div className="reveal" style={{ textAlign: 'center', marginBottom: '56px' }}>
          <span className="section-label">Embark on your Tuscany adventure</span>
          <h2 className="section-title" style={{ color: 'var(--offwhite)' }}>Discover your escape. <em style={{ color: 'var(--gold2)' }}>For fugitives only</em></h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '3px' }}>
          {content.escape.map((item, i) => (
            <div key={i} className="reveal" style={{ transitionDelay: `${i*0.1}s`, position: 'relative', overflow: 'hidden', cursor: 'default' }}
              onMouseEnter={() => setHovered(i)} onMouseLeave={() => setHovered(null)}>
              <img src={`${pub}/${item.image}`} alt={item.label} style={{ width:'100%',height:'380px',objectFit:'cover',display:'block',transition:'transform 0.6s ease',transform:hovered===i?'scale(1.05)':'scale(1)' }} />
              <div style={{ position:'absolute',inset:0,background:hovered===i?'linear-gradient(to top, rgba(14,12,10,0.88) 0%, rgba(14,12,10,0.2) 60%, transparent 100%)':'linear-gradient(to top, rgba(14,12,10,0.55) 0%, transparent 55%)',transition:'background 0.4s',display:'flex',flexDirection:'column',justifyContent:'flex-end',padding:'24px 20px' }}>
                <span style={{ fontFamily:'var(--font-body)',fontSize:'10px',letterSpacing:'0.22em',textTransform:'uppercase',color:'var(--gold2)',marginBottom:'8px',transition:'opacity 0.3s' }}>{item.label}</span>
                <p style={{ fontFamily:'var(--font-title)',fontStyle:'italic',fontSize:'1rem',color:'white',lineHeight:1.4,opacity:hovered===i?1:0,transform:hovered===i?'translateY(0)':'translateY(8px)',transition:'all 0.4s ease' }}>{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
